import { api, qs } from './client.js';

/**
 * 카테고리 랭킹 순위 — 원본 xadmin/management/clarity/list.php.
 * 서버는 modules/categoryRank. 쿼리스트링 키는 원본과 같다.
 */
export type CategoryRankViewType = 'month' | 'week';
export type CategoryRankSortDir = 'ASC' | 'DESC';

export interface CategoryRankParams {
  view_type: CategoryRankViewType;
  /** 'YYYY-MM'(월별) / 'YYYY-MM-DD'(주차별) / '' */
  search_date: string;
  /** 대분류 2자리 코드 - 이 코드로 시작하는 카테고리 전부 */
  search_category: string;
  sort_dir: CategoryRankSortDir;
}

/** [카테고리 코드, PC, 모바일, 합계] - 한 기간 안에서 조회수 정렬 순. */
export type CategoryRankRow = [category: string, p: number, m: number, total: number];

export interface CategoryRankGroup {
  periodKey: number;
  /** '2026-10월' / '2026-42주' */
  period: string;
  /** 이 기간의 조회수 합 (원본 '기간 합계') */
  total: number;
  rows: CategoryRankRow[];
}

/**
 * 주차별 전체는 6천 행이 넘는다 - 행마다 기간 이름·카테고리명을 되풀이하지 않도록
 * 기간별로 묶고 이름은 names 로 한 번만 보낸다.
 */
export interface CategoryRankResult {
  /** 기간 최신순 */
  groups: CategoryRankGroup[];
  /** 행 수 (원본 '조회된 내역') */
  total: number;
  /** 카테고리 코드 → 이름 */
  names: Record<string, string>;
  /** 대분류 선택지 ('콘돔쇼핑 (01)') */
  categories: { value: string; label: string }[];
}

export const categoryRankApi = {
  list: (p: CategoryRankParams) => api.get<CategoryRankResult>(`/reports/category-rank${qs({ ...p })}`),
};
